/**
 * @file Various constants and enums used by MFC
 * @see https://assets.myfreecams.com/_js/mfccore.js
 * This file is generated by __scripts__/generateMfcConstants.ts
 * Do not edit this file directly!
 * Generated on 2022-04-24
 */

/** Initial message to send when connecting as a member */
export const FCSWS_HANDSHAKE_MEMBER = 'fcsws_20180422'
/** Initial message to send when connecting as a model */
export const FCSWS_HANDSHAKE_MODEL = 'fcsws_20211126'
/** Version number to pass along with 'FCTYPE_LOGIN' login requests */
export const FCSWS_LOGIN_VERSION = 20080910
export const FCSWS_MSG_TERMINATOR = '\n\0'
export const FCSWS_PORT = 443
export const FCSWS_SIZE_TAG_LENGTH = 6
/** size tag + 5 numbers + 4 spaces */
export const FCSWS_MIN_PACKET_LENGTH = FCSWS_SIZE_TAG_LENGTH + 9
export const FCSWS_MAGIC = -2027771214

export const CAMCHAN_ID_START = 400000000
export const CAMCHAN_ID_END = 500000000
export const CHANNEL_ID_START = 100000000
export const CHANNEL_ID_END = 400000000
export const CLIENT_VERSION_REQUIRED = 20060925
export const CLUB_ID_START = 0
export const CLUB_ID_END = 2000000000
export const CLUBGROUP_ID_START = 2000000000
export const DISPLAY_PM_INLINE_WHISPER = 1
export const DISPLAY_PM_INLINE_ALL = 2
export const EVSESSION_NONE = 0
export const EVSESSION_PRIVATE = 1
export const EVSESSION_VOYEUR = 2
export const EVSESSION_GROUP = 3
export const EVSESSION_FEATURE = 4
export const EVSESSION_AWAYPVT = 5
export const EVSESSION_CLUB = 6
export const EVSESSION_TIP = 10
export const EVSESSION_PUBLIC = 100
export const EVSESSION_AWAY = 101
export const EVSESSION_START = 102
export const EVSESSION_UPDATE = 103
export const EVSESSION_STOP = 104
export const EVSESSION_SPECIAL = 1000
export const EVUP_NONE = 0
export const EVUP_DIFF = 1
export const EVUP_FULL = 2
export const FCACCEPT_NOBODY = 0
export const FCACCEPT_FRIENDS = 1
export const FCACCEPT_ALL = 2
export const FCACCEPT_V2_NONE = 8
export const FCACCEPT_V2_FRIENDS = 16
export const FCACCEPT_V2_MODELS = 32
export const FCACCEPT_V2_PREMIUMS = 64
export const FCACCEPT_V2_BASICS = 128
export const FCACCEPT_V2_BOOKMARKS = 256
export const FCACCEPT_V2_TOPFRIENDS = 512
export const FCACCEPT_V2_CLUBMEMBERS = 1024
export const FCACT_CHAN_TIP = 1006
export const FCACT_CHAN_BAN = 1011
export const FCACT_CHAN_UNBAN = 1012
export const FCACT_CHAN_JOIN = 1051
export const FCACT_CHAN_PART = 1052
export const FCACT_CHAN_TOPIC = 1061
export const FCACT_CHAN_WHITEBOARD_ON = 1101
export const FCACT_CHAN_WHITEBOARD_OFF = 1102
export const FCACT_LOGIN = 8001
export const FCACT_LOGOUT = 8002
export const FCACT_CHECKIN = 8003
export const FCACT_REFRESH = 8004
export const FCAPP_NONE = 0
export const FCAPP_MASTER = 1
export const FCAPP_CHAT = 2
export const FCAPP_WORKER = 3
export const FCAPP_AUTH = 4
export const FCAPP_LOADTEST = 5
export const FCAPP_TRANSCODER = 6
export const FCAPP_CLIENT = 7
export const FCAPP_FLUX_CLIENT = 32
export const FCAPP_FLUX_SERVICE = 33
export const FCAPP_FLUX_BROKER = 34
export const FCAPP_WWW = 100
export const FCAPP_PROFILES = 101
export const FCAPP_MOBILE = 102
export const FCAPP_IMG = 103
export const FCAPP_API = 104
export const FCAPP_ADMIN = 105
export const FCAPP_ARCHIVE = 204
export const FCAPP_DATABASE = 205
export const FCAPP_FMS = 500
export const FCAPP_WOWZA = 501
export const FCAPP_WOWZA_RELAY = 502
export const FCAPP_WOWZA_CAM2CAM = 503
export const FCAPP_WOWZA_OBSRTC_V1 = 506
export const FCAPP_WOWZA_OBSRTC_V2 = 507
export const FCAPP_WOWZA_OBS = 508
export const FCAPP_WOWZA_OBSEXT = 509
export const FCAPP_NGINX = 510
export const FCAPP_NGX_INGEST = 512
export const FCAPP_FMS_SHARED = 801
export const FCAPP_CAM2CAM = 802
export const FCAPP_FMS_ORIGIN = 803
export const FCAPP_FMS_EDGE = 804
export const FCAPP_OAUTH_IDENTITY = 901
export const FCAPP_OAUTH_CLIENT = 902
export const FCAPP_API_GATEWAY = 951
export const FCBAN_NONE = 0
export const FCBAN_TEMP = 1
export const FCBAN_60DAY = 2
export const FCBAN_LIFE = 3
export const FCCHAN_EVENT_NONE = 0
export const FCCHAN_NOOPT = 0
export const FCCHAN_EVENT_CLEARCHAT = 1
export const FCCHAN_JOIN = 1
export const FCCHAN_ERR_NOCHANNEL = 2
export const FCCHAN_EVENT_MUTE = 2
export const FCCHAN_PART = 2
export const FCCHAN_ERR_NOTMEMBER = 3
export const FCCHAN_EVENT_TOPIC = 3
export const FCCHAN_ERR_GUESTMUTE = 4
export const FCCHAN_EVENT_COUNTDOWN = 4
export const FCCHAN_OLDMSG = 4
export const FCCHAN_ERR_GROUPMUTE = 5
export const FCCHAN_EVENT_KICK = 5
export const FCCHAN_ERR_NOTALLOWED = 6
export const FCCHAN_EVENT_WHITEBOARD_ON = 6
export const FCCHAN_EVENT_WHITEBOARD_OFF = 7
export const FCCHAN_EVENT_RESERVED_008 = 8
export const FCCHAN_HISTORY = 8
export const FCCHAN_EVENT_RESERVED_009 = 9
export const FCCHAN_EVENT_RESERVED_010 = 10
export const FCCHAN_EVENT_RESERVED_011 = 11
export const FCCHAN_EVENT_RESERVED_012 = 12
export const FCCHAN_EVENT_RESERVED_013 = 13
export const FCCHAN_EVENT_RESERVED_014 = 14
export const FCCHAN_EVENT_RESERVED_015 = 15
export const FCCHAN_EVENT_RESERVED_016 = 16
export const FCCHAN_LIST = 16
export const FCCHAN_EVENT_RESERVED_017 = 17
export const FCCHAN_EVENT_RESERVED_018 = 18
export const FCCHAN_EVENT_RESERVED_019 = 19
export const FCCHAN_WELCOME = 32
export const FCCHAN_BATCHPART = 64
export const FCCHAN_EXT_USERNAME = 128
export const FCCHAN_EXT_USERDATA = 256
export const FCCHAN_NO_CHANGES = 512
export const FCCHAN_APPEND = 1024
export const FCCHAN_REPLACE = 2048
export const FCCHAN_UPDATE = 4096
export const FCCHAN_QUERY = 8192
export const FCCHAN_EXPIRE = 16384
export const FCCHAN_NOTIFY = 32768
export const FCCHAN_APPLY = 65536
export const FCCHAN_IMPORT = 131072
export const FCCHAN_BATCH = 262144
export const FCCHAN_TRUNCATE = 524288
export const FCGROUP_NONE = 0
export const FCGROUP_EXPIRED = 1
export const FCGROUP_BUSY = 2
export const FCGROUP_EMPTY = 3
export const FCGROUP_DECLINED = 4
export const FCGROUP_UNAVAILABLE = 5
export const FCGROUP_SESSION = 9
export const FCL_NULL = 0
export const FCL_FRIENDS = 1
export const FCL_IGNORES = 2
export const FCL_BOOKMARKS = 3
export const FCL_HIDDEN = 4
export const FCL_HPFRIENDS = 5
export const FCL_TOPFRIENDS = 6
export const FCL_NEWS_SUBS = 7
export const FCL_NEWS_HIDDEN = 8
export const FCL_MYWEBCAM_ALLOW = 9
export const FCL_MYWEBCAM_DENY = 10
export const FCL_BLOCKS_STATES = 11
export const FCL_BLOCKS_COUNTRIES = 12
export const FCL_ROOMFILTERS = 13
export const FCL_BANS = 14
export const FCL_MUTES = 15
export const FCL_UEOPTS = 16
export const FCL_RESERVED_17 = 17
export const FCL_RESERVED_18 = 18
export const FCL_RESERVED_19 = 19
export const FCL_TAGS = 20
export const FCL_CAMS = 21
export const FCL_ROOMMATES = 22
export const FCL_SOCIALDATA = 23
export const FCL_SHARE_CLUBS = 24
export const FCL_SHARE_CLUBMEMBERSHIPS = 25
export const FCL_SHARE_CLUBSHOWS = 26
export const FCL_SHARE_BADGES = 27
export const FCL_SESSIONS = 28
export const FCL_CHANNELS = 29
export const FCL_RESERVED_30 = 30
export const FCLEVEL_GUEST = 0
export const FCLEVEL_BASIC = 1
export const FCLEVEL_PREMIUM = 2
export const FCLEVEL_MODEL = 4
export const FCLEVEL_ADMIN = 5
export const FCMODEL_NONE = 0
export const FCMODEL_NOGROUP = 1
export const FCMODEL_FEATURE1 = 2
export const FCMODEL_FEATURE2 = 4
export const FCMODEL_FEATURE3 = 8
export const FCMODEL_FEATURE4 = 16
export const FCMODEL_FEATURE5 = 32
export const FCNEWSOPT_NONE = 0
export const FCNEWSOPT_IN_CHAN = 1
export const FCNEWSOPT_IN_PM = 2
export const FCNEWSOPT_AUTOFRIENDS_OFF = 4
export const FCNEWSOPT_IN_CHAN_NOPVT = 8
export const FCNEWSOPT_IN_CHAN_NOGRP = 16
export const FCNOSESS_NONE = 0
export const FCNOSESS_PVT = 1
export const FCNOSESS_GRP = 2
export const FCNOSESS_TRUEPVT = 4
export const FCNOSESS_TOKEN_MIN = 8
export const FCNOSESS_PLATFORM = 16
export const FCNOSESS_VIDEOSERVER = 32
export const FCNOSESS_INVALID_STATE = 64
export const FCNOSESS_MODEL_SETTINGS = 128
export const FCNOSESS_CLIENT_ERROR = 256
export const FCOPT_NONE = 0
export const FCOPT_BOLD = 1
export const FCOPT_ITALICS = 2
export const FCOPT_REMOTEPVT = 4
export const FCOPT_TRUEPVT = 8
export const FCOPT_CAM2CAM = 16
export const FCOPT_RGNBLOCK = 32
export const FCOPT_TOKENAPPROX = 64
export const FCOPT_TOKENHIDE = 128
export const FCOPT_RPAPPROX = 256
export const FCOPT_RPHIDE = 512
export const FCOPT_HDVIDEO = 1024
export const FCOPT_MODELSW = 2048
export const FCOPT_GUESTMUTE = 4096
export const FCOPT_BASICMUTE = 8192
export const FCOPT_SMALLCAPS = 16384
export const FCOPT_XMPP = 32768
export const FCOPT_WHITEBOARD1 = 65536
export const FCOPT_WHITEBOARD2 = 131072
export const FCOPT_ATTACHED = 262144
export const FCOPT_WEBRTCV1 = 524288
export const FCOPT_OBSRTCV1 = 1048576
export const FCOPT_OBSRTCV2 = 2097152
export const FCOPT_SIDEKICK = 4194304
export const FCOPT_SPLITCAM = 8388608
export const FCOPT_AGENT = 16777216
export const FCOPT_OBSCUSTOM = 33554432
export const FCPORT_EDGE_POLICY = 843
export const FCPORT_MASTER_EDGE = 4000
export const FCPORT_MASTER_AUTH = 4001
export const FCPORT_AUTH_DATAGRAM = 4002
export const FCPORT_MASTER_WORKER = 4003
export const FCPORT_EDGE_WORKER = 4004
export const FCPORT_EDGE_CLIENT1 = 5001
export const FCPORT_EDGE_AJAX = 8080
export const FCPORT_EDGE_LIBWEBSOCK = 8080
export const FCPORT_EDGE_CLIENT3 = 8100
export const FCPORT_EDGE_WEBSOCKGW = 8101
export const FCPORT_EDGE_CLIENT2 = 8550
export const FCPORT_WORKER_BASE = 9000
export const FCQ_NULL = 0
export const FCQ_SESSIONS = 1
export const FCQ_USERS = 2
export const FCQ_SETTINGS = 3
export const FCQ_IDX = 4
export const FCQ_CHANNEL = 5
export const FCQ_PM = 6
export const FCQ_ACTLOG = 7
export const FCQ_GENERAL = 8
export const FCQ_MODELUSAGE = 9
export const FCQ_LASTLOGIN = 10
export const FCQ_LASTCHAT = 11
export const FCQ_RESERVED_12 = 12
export const FCQ_RESERVED_13 = 13
export const FCQ_RESERVED_14 = 14
export const FCQ_RESERVED_15 = 15
export const FCQ_MAX_SZ = 16
export const FCRESPONSE_SUCCESS = 0
export const FCRESPONSE_ERROR = 1
export const FCRESPONSE_NOTICE = 2
export const FCRESPONSE_SUSPEND = 3
export const FCRESPONSE_SHUTOFF = 4
export const FCRESPONSE_WARNING = 5
export const FCRESPONSE_QUEUED = 6
export const FCRESPONSE_NO_RESULTS = 7
export const FCRESPONSE_CACHED = 8
export const FCRESPONSE_JSON = 9
export const FCRESPONSE_INVALIDUSER = 10
export const FCRESPONSE_NOACCESS = 11
export const FCRESPONSE_NOSPACE = 12
export const FCRESPONSE_INVALIDREQ = 13
export const FCRESPONSE_INVALIDARG = 14
export const FCRESPONSE_NOTFOUND = 15
export const FCRESPONSE_INSUFFICIENT = 16
export const FCRESPONSE_EXPIRED = 17
export const FCRESPONSE_BINARY = 18
export const FCRESPONSE_UNKNOWN = 255
export const FCRPC_NONE = 0
export const FCRPC_UPDATEFRIEND = 1
export const FCRPC_UPDATEIGNORE = 2
export const FCRPC_RESLOADED = 3
export const FCRPC_W_READY = 4
export const FCRPC_W_OFFLINEQUERY = 5
export const FCRPC_W_FRIENDLIST = 6
export const FCRPC_W_IGNORELIST = 7
export const FCRPC_W_EXT_REQUEST = 8
export const FCRPC_W_EXT_RESPONSE = 9
export const FCRPC_FCSVAR = 10
export const FCRPC_RELAY_HOOK = 11
export const FCRPC_RELAY_FILTER = 12
export const FCRPC_W_REGISTER = 13
export const FCRPC_W_SUBSCRIBE = 14
export const FCRPC_W_PROXYMSG = 15
export const FCS_SUBSCRIBE = 1
export const FCS_SYNC = 2
export const FCS_SESSION = 10
export const FCS_BAN = 11
export const FCS_MODEL = 12
export const FCS_EVENT = 13
export const FCS_EVENT2 = 14
export const FCS_EXTDATA = 15
export const FCS_GWCONNECT = 16
export const FCS_MUTE = 18
export const FCS_AUTHREQ = 100
export const FCS_BANREQ = 101
export const FCS_EVENTREQ = 102
export const FCS_EVENTRESP = 103
export const FCS_SENDEVENT = 104
export const FCS_SENDEVENT2 = 105
export const FCSBAN_NONE = 0
export const FCSBAN_USER = 1
export const FCSBAN_IP = 2
export const FCTYPE_CLIENT_MANUAL_DISCONNECT = -6
export const FCTYPE_CLIENT_DISCONNECTED = -5
export const FCTYPE_CLIENT_MODELSLOADED = -4
export const FCTYPE_CLIENT_CONNECTED = -3
export const FCTYPE_ANY = -2
export const FCTYPE_UNKNOWN = -1
export const FCTYPE_NULL = 0
export const FCTYPE_LOGIN = 1
export const FCTYPE_ADDFRIEND = 2
export const FCTYPE_PMESG = 3
export const FCTYPE_STATUS = 4
export const FCTYPE_DETAILS = 5
export const FCTYPE_TOKENINC = 6
export const FCTYPE_ADDIGNORE = 7
export const FCTYPE_PRIVACY = 8
export const FCTYPE_ADDFRIENDREQ = 9
export const FCTYPE_USERNAMELOOKUP = 10
export const FCTYPE_ZBAN = 11
export const FCTYPE_BROADCASTNEWS = 12
export const FCTYPE_ANNOUNCE = 13
export const FCTYPE_MANAGELIST = 14
export const FCTYPE_INBOX = 15
export const FCTYPE_GWCONNECT = 16
export const FCTYPE_RELOADSETTINGS = 17
export const FCTYPE_HIDEUSERS = 18
export const FCTYPE_RULEVIOLATION = 19
export const FCTYPE_SESSIONSTATE = 20
export const FCTYPE_REQUESTPVT = 21
export const FCTYPE_ACCEPTPVT = 22
export const FCTYPE_REJECTPVT = 23
export const FCTYPE_ENDSESSION = 24
export const FCTYPE_TXPROFILE = 25
export const FCTYPE_STARTVOYEUR = 26
export const FCTYPE_SERVERREFRESH = 27
export const FCTYPE_SETTING = 28
export const FCTYPE_BWSTATS = 29
export const FCTYPE_TKX = 30
export const FCTYPE_SETTEXTOPT = 31
export const FCTYPE_SERVERCONFIG = 32
export const FCTYPE_MODELGROUP = 33
export const FCTYPE_REQUESTGRP = 34
export const FCTYPE_STATUSGRP = 35
export const FCTYPE_GROUPCHAT = 36
export const FCTYPE_CLOSEGRP = 37
export const FCTYPE_UCR = 38
export const FCTYPE_MYUCR = 39
export const FCTYPE_SLAVECON = 40
export const FCTYPE_SLAVECMD = 41
export const FCTYPE_SLAVEFRIEND = 42
export const FCTYPE_SLAVEVSHARE = 43
export const FCTYPE_ROOMDATA = 44
export const FCTYPE_NEWSITEM = 45
export const FCTYPE_GUESTCOUNT = 46
export const FCTYPE_PRELOGINQ = 47
export const FCTYPE_MODELGROUPSZ = 48
export const FCTYPE_ROOMHELPER = 49
export const FCTYPE_CMESG = 50
export const FCTYPE_JOINCHAN = 51
export const FCTYPE_CREATECHAN = 52
export const FCTYPE_INVITECHAN = 53
export const FCTYPE_RPC = 54
export const FCTYPE_QUIETCHAN = 55
export const FCTYPE_BANCHAN = 56
export const FCTYPE_PREVIEWCHAN = 57
export const FCTYPE_SHUTDOWN = 58
export const FCTYPE_LISTBANS = 59
export const FCTYPE_UNBAN = 60
export const FCTYPE_SETWELCOME = 61
export const FCTYPE_CHANOP = 62
export const FCTYPE_LISTCHAN = 63
export const FCTYPE_TAGS = 64
export const FCTYPE_SETPCODE = 65
export const FCTYPE_SETMINTIP = 66
export const FCTYPE_UEOPT = 67
export const FCTYPE_HDVIDEO = 68
export const FCTYPE_METRICS = 69
export const FCTYPE_OFFERCAM = 70
export const FCTYPE_REQUESTCAM = 71
export const FCTYPE_MYWEBCAM = 72
export const FCTYPE_MYCAMSTATE = 73
export const FCTYPE_PMHISTORY = 74
export const FCTYPE_CHATFLASH = 75
export const FCTYPE_TRUEPVT = 76
export const FCTYPE_BOOKMARKS = 77
export const FCTYPE_EVENT = 78
export const FCTYPE_STATEDUMP = 79
export const FCTYPE_RECOMMEND = 80
export const FCTYPE_EXTDATA = 81
export const FCTYPE_NOTIFY = 84
export const FCTYPE_PUBLISH = 85
export const FCTYPE_XREQUEST = 86
export const FCTYPE_XRESPONSE = 87
export const FCTYPE_EDGECON = 88
export const FCTYPE_XMESG = 89
export const FCTYPE_CLUBSHOW = 90
export const FCTYPE_CLUBCMD = 91
export const FCTYPE_AGENT = 92
export const FCTYPE_RESERVED_93 = 93
export const FCTYPE_RESERVED_94 = 94
export const FCTYPE_ZGWINVALID = 95
export const FCTYPE_CONNECTING = 96
export const FCTYPE_CONNECTED = 97
export const FCTYPE_DISCONNECTED = 98
export const FCTYPE_LOGOUT = 99
export const FCTYPE_XRPC = 1000
export const FCUCR_CREATOR = 0
export const FCUCR_VM_LOUNGE = 0
export const FCUCR_FRIENDS = 1
export const FCUCR_VM_MYWEBCAM = 1
export const FCUCR_MODELS = 2
export const FCUCR_PREMIUMS = 4
export const FCUCR_BASICS = 8
export const FCUCR_ALL = 15
export const FCUOPT_EMPTY = 0
export const FCUOPT_PLATFORM_MFC = 1
export const FCUOPT_PLATFORM_CAMYOU = 2
export const FCUOPT_PLATFORM_OFFLINE = 4
export const FCUOPT_PLATFORM_XSDEFAULT = 8
export const FCUOPT_RESERVED_05 = 16
export const FCUOPT_RESERVED_06 = 32
export const FCUOPT_RESERVED_07 = 64
export const FCUOPT_LOG_XMESG = 128
export const FCUOPT_RESERVED_09 = 256
export const FCUOPT_RESERVED_10 = 512
export const FCUOPT_RESERVED_11 = 1024
export const FCUOPT_RESERVED_12 = 2048
export const FCUOPT_RESERVED_13 = 4096
export const FCUOPT_RESERVED_14 = 8192
export const FCUOPT_RESERVED_15 = 16384
export const FCUOPT_RESERVED_16 = 32768
export const FCUOPT_FLAG_ACCT = 65536
export const FCUOPT_FLAG_HDVIDEO = 131072
export const FCUOPT_FLAG_MODELSW = 262144
export const FCUOPT_FLAG_XMPP = 524288
export const FCUOPT_FLAG_WHITEBOARD1 = 1048576
export const FCUOPT_FLAG_WHITEBOARD2 = 2097152
export const FCUOPT_FLAG_ATTACHED = 4194304
export const FCUOPT_FLAG_WEBRTCV1 = 8388608
export const FCUOPT_FLAG_NG_EDGE = 16777216
export const FCUOPT_FLAG_NG_ADDR_ORIGIN = 33554432
export const FCUOPT_FLAG_OBSRTCV1 = 67108864
export const FCUOPT_FLAG_OBSRTCV2 = 134217728
export const FCUOPT_FLAG_SIDEKICK = 268435456
export const FCUOPT_FLAG_SPLITCAM = 536870912
export const FCUOPT_FLAG_LWSCHAT = 1099511627776
export const FCUPDATE_NONE = 0
export const FCUPDATE_MISSMFC = 1
export const FCUPDATE_NEWTIP = 2
export const FCUPDATE_REGION_SAFE = 3
export const FCUPDATE_CAMSCORE = 4
export const FCUPDATE_ROOMFILTER = 5
export const FCUPDATE_CLUBMEMBERSHIP = 6
export const FCUPDATE_CLUB = 7
export const FCUPDATE_CLUBCACHE = 8
export const FCUPDATE_SHAREDATA = 9
export const FCUSER_TESTCAM2 = 469516
export const FCUSER_TESTCAM3 = 469517
export const FCUSER_TESTCAM1 = 469518
export const FCUSER_MFCNEWS = 481462
export const FCUSER_CAMNEWS = 481464
export const FCUSER_LOUNGE = 486121
export const FCUSER_LOUNGE1K = 486123
export const FCUSER_LOUNGE10K = 486124
export const FCUSER_CAM_LOUNGE = 486128
export const FCUSER_MFCSHARE = 1535156
export const FCUSER_CAMSHARE = 1535157
export const FCVIDEO_TX_IDLE = 0
export const FCVIDEO_TX_RESET = 1
export const FCVIDEO_TX_AWAY = 2
export const FCVIDEO_TX_CONFIRMING = 11
export const FCVIDEO_TX_PVT = 12
export const FCVIDEO_TX_GRP = 13
export const FCVIDEO_TX_CLUB = 14
export const FCVIDEO_TX_KILLMODEL = 15
export const FCVIDEO_C2C_ON = 20
export const FCVIDEO_C2C_OFF = 21
export const FCVIDEO_RX_IDLE = 90
export const FCVIDEO_RX_PVT = 91
export const FCVIDEO_RX_VOY = 92
export const FCVIDEO_RX_GRP = 93
export const FCVIDEO_RX_CLUB = 94
export const FCVIDEO_NULL = 126
export const FCVIDEO_OFFLINE = 127
export const FCW_STATE_INIT = 0
export const FCW_STATE_READY = 1
export const FCW_STATE_WORKING = 2
export const FCW_STATE_WAITING = 3
export const FCW_STATE_INVALID = 4
export const FCWOPT_NONE = 0
export const FCWOPT_ADD = 1
export const FCWOPT_REMOVE = 2
export const FCWOPT_LIST = 4
export const FCWOPT_NO_RECEIPT = 128
export const FCWOPT_REDIS_JSON = 256
export const FCWOPT_USERID = 1024
export const FCWOPT_USERDATA = 2048
export const FCWOPT_USERNAME = 4096
export const FCWOPT_C_USERNAME = 32768
export const FCWOPT_C_MONTHSLOGIN = 65536
export const FCWOPT_C_LEVEL = 131072
export const FCWOPT_C_VSTATE = 262144
export const FCWOPT_C_CHATTEXT = 524288
export const FCWOPT_C_PROFILE = 1048576
export const FCWOPT_C_AVATAR = 2097152
export const FCWOPT_C_RANK = 4194304
export const FCWOPT_C_SDATE = 8388608
export const FVT_NONE = 0
export const FVT_PUBLIC = 1
export const FVT_PRIVATE = 2
export const FVT_GROUP = 4
export const FVT_MYWEBCAM = 8
export const FVT_CLUB = 16
export const FVT_VOYEUR = 32
export const FVT_RESERVED_64 = 64
export const FVT_ACL_GUEST = 128
export const FVT_ACL_BASIC = 256
export const FVT_ACL_PREMIUM = 512
export const FVT_ACL_MODEL = 1024
export const FVT_ACL_ADMIN = 2048
export const FVT_ACL_ALL = 3968
export const FVT_ALLOW_PUBLISH = 4096
export const FVT_ALLOW_VIEW = 8192
export const FVT_ALLOW_PREVIEW = 16384
export const FVT_ALLOW_MANAGE = 32768
export const FVT_ALLOW_TRANSCODE = 65536
export const FVT_ALLOW_MONITOR_STREAMS = 131072
export const FVT_ALLOW_MONITOR_CLIENTS = 262144
export const FVT_OBS_RTMP = 524288
export const FVT_OBS_WEBRTC_V1 = 1048576
export const FVT_OBS_WEBRTC_V2 = 2097152
export const FVT_MWEB_RTMP = 4194304
export const FVT_MWEB_WEBRTC = 8388608
export const FVT_MWEB_RES1 = 16777216
export const FVT_OBS_CUSTOM = 33554432
export const HIDE_MODEL_GROUPS_AWAY = 1
export const HIDE_MODEL_GROUPS_PRIVATE = 2
export const HIDE_MODEL_GROUPS_GROUP = 4
export const HIDE_MODEL_GROUPS_PUBLIC = 8
export const LOUNGE_MASK_AUTO_CLICK = 1
export const LOUNGE_MASK_NO_CAMSNAPS = 2
export const LOUNGE_MASK_LOUNGE_MODE = 4
export const MAX_FCL = 31
export const MFC_NEWS_USER_ID = 481462
export const MODEL_LIST_ICON_NEW_MODEL = 1
export const MODEL_LIST_ICON_RECOMMEND = 2
export const MODEL_LIST_ICON_POPULAR = 4
export const MODEL_LIST_ICON_RECENT = 8
export const MODEL_LIST_ICON_MISSMFC = 16
export const MODEL_LIST_ICON_TRENDING = 32
export const MODEL_LIST_ICON_CUSTOM_ALERTS = 64
export const MODEL_VERSION_REQUIRED = 220170401
export const MODEL_VERSION_MODELWEB = 320110101
export const MODELORDER_NONE = 0
export const MODELORDER_PVT = 1
export const MODELORDER_TRUEPVT = 2
export const MODELORDER_GRP = 4
export const MYWEBCAM_EVERYONE = 0
export const MYWEBCAM_ONLYUSERS = 1
export const MYWEBCAM_ONLYFRIENDS = 2
export const MYWEBCAM_ONLYMODELS = 3
export const MYWEBCAM_FRIENDSANDMODELS = 4
export const MYWEBCAM_WHITELIST = 5
export const MYWEBCAM_FRIEND_ID = 100
export const OBSMON_NULL = 0
export const OBSMON_APPROVING = 10
export const OBSMON_UNAPPROVED = 11
export const OBSMON_READY = 12
export const OBSMON_ACTIVE = 20
export const OBSMON_TIMEOUT = 30
export const OBSMON_INACTIVE = 31
export const OBSMON_CLOSED = 32
export const PLAT_MFC = 1
export const PLAT_CAM = 2
export const PLATFORM_NONE = 0
export const PLATFORM_MFC = 1
export const PLATFORM_CAMMUNITY = 2
export const PLATFORM_CAMYOU = 2
export const ROOMFILTER_EMPTY = 0
export const ROOMFILTER_LOG = 1
export const ROOMFILTER_DROP = 2
export const ROOMFILTER_WARN = 4
export const ROOMFILTER_REGEX = 8
export const ROOMFILTER_SPECIAL = 16
export const ROOMFILTER_FROMHELPER = 32
export const ROOMFILTER_EXACT_WORD = 64
export const ROOMFILTER_RESERVED_7 = 128
export const ROOMFILTER_RESERVED_8 = 256
export const ROOMFILTER_RESERVED_9 = 512
export const ROOMFILTER_IS_GUEST = 1024
export const ROOMFILTER_IS_BASIC = 2048
export const ROOMFILTER_IS_PREMIUM = 4096
export const ROOMFILTER_IS_MODEL = 8192
export const ROOMFILTER_IN_PUBLIC = 16384
export const ROOMFILTER_IN_SESSION = 32768
export const ROOMFILTER_RESERVED_16 = 65536
export const ROOMFILTER_RESERVED_17 = 131072
export const ROOMFILTER_RESERVED_18 = 262144
export const ROOMFILTER_RESERVED_19 = 524288
export const ROOMFILTER_RESERVED_20 = 1048576
export const SERVER_VERSION = 20071218
export const SERVER_VERSION_REQUIRED = 20071218
export const SESSCHAN_ID_START = 200000000
export const SESSCHAN_ID_END = 300000000
export const SESSION_ID_START = 75000000
export const SESSION_ID_END = 950000000
export const TKOPT_NONE = 0
export const TKOPT_START = 1
export const TKOPT_STOP = 2
export const TKOPT_OPEN = 4
export const TKOPT_PVT = 8
export const TKOPT_VOY = 16
export const TKOPT_GRP = 32
export const TKOPT_CLUB = 64
export const TKOPT_TIP = 256
export const TKOPT_TIP_HIDDEN_AMT = 512
export const TKOPT_TIP_OFFLINE = 1024
export const TKOPT_TIP_MSG = 2048
export const TKOPT_TIP_ANON = 4096
export const TKOPT_TIP_PUBLIC = 8192
export const TKOPT_TIP_FROMROOM = 16384
export const TKOPT_TIP_PUBLICMSG = 32768
export const TKOPT_TIP_HISTORY = 65536
export const TKOPT_TIP_SILENT = 131072
export const TKOPT_TIP_NOCOUNT = 262144
export const TKOPT_HDVIDEO = 1048576
export const TKOPT_TIP_OFFLINE_USER = 2097152
export const TKOPT_TIP_OFFLINE_MODEL = 4194304
export const TKOPT_TIP_PURCHASE = 8388608
export const TKOPT_TIP_PURCHASE_CLUB = 16777216
export const TKOPT_TIP_PURCHASE_GOAL = 33554432
export const TKOPT_TIP_PURCHASE_NOTIFY = 67108864
export const TKOPT_TIP_PURCHASE_LINK = 134217728
export const TKOPT_TIP_PURCHASE_ALBUM = 268435456
export const TKOPT_TIP_PURCHASE_COLLECTION = 536870912
export const TKOPT_TIP_PURCHASE_STOREITEM = 1073741824
export const TKOPT_TIP_PURCHASE_OTHER = 2147483648
export const USER_ID_START = 100
export const USER_ID_END = 50000000
export const USEREXT_NUM = 0
export const USEREXT_STRING = 1
export const USEREXT_DATA = 2
export const USEREXT_STAMP = 3
export const V1_FLV = 0
export const V1_F4V = 1
export const V2_NONE = 2
export const V2_FLV = 4
export const V2_F4V = 8
export const V2_MP4X = 16
export const V2_MP4W = 32
export const VST_FMS = 0
export const VST_WOWZA = 1
export const VST_WOWZA_RELAY = 2
export const VST_WOWZA_CAM2CAM = 3
export const VST_WOWZA_OBSRTC_V1 = 6
export const VST_WOWZA_OBSRTC_V2 = 7
export const VST_WOWZA_OBS = 8
export const VST_NGINX = 10
export const VST_NULL = 255
export const WEBCAM_SECURITY_EVERYONE = 0
export const WEBCAM_SECURITY_FRIENDS = 2
export const WEBCAM_SECURITY_MODELS = 3
export const WEBCAM_SECURITY_MODELS_FRIENDS = 4
export const WEBCAM_SECURITY_ALLOWED = 5
export const WEBCAM_SECURITY_FRIEND_ID = 100
export const WINDOW_MODE_DEFAULT = 0
export const WINDOW_MODE_DESKTOP_DHTML = 1
export const WINDOW_MODE_DHTML = 1
export const WINDOW_MODE_BROWSER = 2
export const WINDOW_MODE_MOBILE_DHTML = 2
export const WORKER_ID_START = 50000000
export const WORKER_ID_END = 75000000
export const WREQUEST_ID_START = 500000000
export const WREQUEST_ID_END = 600000000
